import React, { Component } from 'react'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import { isMobile } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { getApiDatas } from "../../utilities/FrontFunctions/AoxFrontFunctions"

import ModalPhoneMandatory from '../inc/Modal/ModalPhoneMandatory'
import ModalInfosMandatory from '../inc/Modal/ModalInfosMandatory'
import ModalEspaceExclu from '../inc/Modal/ModalEspaceExclu'
import SectionHeroHome2026 from './SectionHeroHome2026'
import SectionPushHero2026 from './SectionPushHero2026'
import SectionBanner2026 from './SectionBanner2026'
import SectionServices2026 from './SectionServices2026'
import SectionNouveautes2026 from './SectionNouveautes2026'
import ObjNoticeAppMobile from '../inc/ObjNoticeAppMobile'


class PageHome extends Component {
	constructor(props) {
		super(props)
		this.state = {
			apiDatas:[],
			IsReadyApiDatas:false,
			isMobile: isMobile()
		}
	}

	async componentDidMount() {
		document.body.classList.add('pg_home2026', 'toast_notice-app_is-visible');
		window.scrollTo(0,0)

        const scDatas = this.props.fields.data;
		const apiDatas = await getApiDatas(`/apiaox/Home/GetDataPageHome`)
		this.setState({ apiDatas:apiDatas, IsReadyApiDatas:true})

        var isOpenSomething = false;

		// popin Info phone (pour event registrations)
		if(!isOpenSomething && this.props.fields.data?.CurrentUser?.needphone === true) {
            this.ModalPhoneMandatory.openModal();
            isOpenSomething = true;
        }

		// popin Info contact
		if(!isOpenSomething && this.props.fields.data?.CurrentUser?.needcontactinformation === true) {
            this.ModalInfosMandatory.openModal()
            isOpenSomething = true;
        }

		// popin concours filtré PDV
		if(!isOpenSomething && scDatas.PopinEspaceExclu?.codesPDVAuthorises?.jss.value.length > 0 && scDatas.CurrentUser?.salepointCode) {
            if(scDatas.PopinEspaceExclu.codesPDVAuthorises.jss.value.split("|").map(code => code.trim()).includes(scDatas.CurrentUser.salepointCode)){
                if(!localStorage.getItem('dontShowAgainModalEspaceExclu')){
                    this.ModalEspaceExclu.openModal();
                    isOpenSomething = true;
                }
            }
        }

	}
	componentWillUnmount() {
		document.body.classList.remove('pg_home2026', 'toast_notice-app_is-visible');
	}

	
	render() {
		const scFields = this.props.sitecoreContext.route?.fields;
		const scDatas = this.props.fields.data;
		const apiDatas = this.state.apiDatas;

		return (<>{this.state.IsReadyApiDatas && scDatas && <>
            {this.props.fields.data?.CurrentUser?.needphone === true &&
                <ModalPhoneMandatory onRef={ref => (this.ModalPhoneMandatory = ref)} modalUrlInfosPeros={scDatas?.PageInfoPerso.url} />
            }

            {this.props.fields.data?.CurrentUser?.needcontactinformation === true &&
                <ModalInfosMandatory onRef={ref => (this.ModalInfosMandatory = ref)} modalUrlInfosPeros={scDatas?.PageInfoPerso.url} />
            }
            
            {scDatas.PopinEspaceExclu?.codesPDVAuthorises?.jss.value.length > 0 && scDatas.CurrentUser?.salepointCode &&
                scDatas.PopinEspaceExclu.codesPDVAuthorises.jss.value.split("|").map(code => code.trim()).includes(scDatas.CurrentUser.salepointCode) &&
                <ModalEspaceExclu onRef={ref => (this.ModalEspaceExclu = ref)} scData={scDatas.PopinEspaceExclu} />
            }

			<SectionHeroHome2026  scFields={scFields} scDatas={scDatas} apiDatas={apiDatas}/>

			<SectionPushHero2026  scFields={scFields} scDatas={scDatas} apiDatas={apiDatas}/>
			
			<SectionBanner2026  scFields={scFields} scDatas={scDatas} apiDatas={apiDatas}/>

			<SectionServices2026  scFields={scFields} scDatas={scDatas} apiDatas={apiDatas}/>

			<SectionNouveautes2026  scFields={scFields} scDatas={scDatas} apiDatas={apiDatas}/>

			{ this.state.isMobile &&
				<ObjNoticeAppMobile />
			}
		</>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageHome));